/**
 * @generated SignedSource<<335e054376a7588536f9efecd568d0b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OpenEndElement_screener$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ElementBase_screener">;
  readonly " $fragmentType": "OpenEndElement_screener";
};
export type OpenEndElement_screener$key = {
  readonly " $data"?: OpenEndElement_screener$data;
  readonly " $fragmentSpreads": FragmentRefs<"OpenEndElement_screener">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OpenEndElement_screener",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ElementBase_screener"
    }
  ],
  "type": "ScreenerNode",
  "abstractKey": null
};

(node as any).hash = "3fedddc406d12dbd6e380eaccc8ea80f";

export default node;
